import AboutJobTitle from './AboutJobTitle'
export default AboutJobTitle
